export default __webpack_public_path__ + "static/media/1010.28a69bf3.png";